import { Fragment, useContext, useEffect, useState, useCallback } from 'react';

import './DetailsPhone.scss';
import { Col, Form, Row,Button, InputGroup } from 'react-bootstrap';
import Toast from '../../../Form/Toast';
import messageSquare from '../../../../assets/icons/message-square.svg';
import phone from '../../../../assets/icons/phone-call.svg';
import messageSquareActive from '../../../../assets/icons/message-square-blue.svg';
import phoneActive from '../../../../assets/icons/phone-call-blue.svg';
import eye from '../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../assets/icons/outline_eye_bright-off.svg';
import Ajax from '../../../../Handler/Ajax';
import GovSpinner from '../../../Form/GovSpinner';
import alert from '../../../../assets/icons/alert-circle-red.svg';
import info from '../../../../assets/icons/info-blue.svg';
import timer from '../../../../assets/icons/timer.svg';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';
import ReactInternationalPhone from '../../../Form/ReactInternationalPhone/ReactInternationalPhone';
import LoginContext from '../../../../store/login-context';
import { useWebOtp } from '../../Static/WebOtp/useWebOtp';

declare function Translate(key: string): string;
declare var _curLang: any;

const DetailsPhone = props => {

  const ctx = useContext(LoginContext);
  
  const [typedNumber, setTypedNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isPhoneConfirmValid, setIsPhoneConfirmValid] = useState(false);
  const [phoneDirty, setPhoneDirty] = useState(false);
  const [phoneConfirmDirty, setPhoneConfirmDirty] = useState(false);
  const [otpType, setOtpType] = useState('SMS');
  const [step, setStep] = useState(1);
  const [phoneTemplate, setPhoneTemplate] = useState('');
  const [controlType, setControlType] = useState('password');
  const [otpCode, setOtpCode] = useState('');
  const [otpDirty, setOtpDirty] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serverMessage, setServerMessage] = useState('');
  const [isResendOtpEnabled, setIsResendOtpEnabled] = useState(false);
  const [mobileValMsg, setMobileValMsg] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('il');
  const [confirmErr, setConfirmErr] = useState('');
  const [confirmPhoneNumber, setConfirmPhoneNumber] = useState('');
  const [resetConfirm, setResetConfirm] = useState(false);

  useEffect(() => {
    if(props.currentState === "updateDetailsGetMobileOtpInput"){
      setStep(2);
    }
  },[]);


  // auto otp - start
  const handleWebOtp = useCallback((code: string) => {    
    setOtpCode(code.replace(/[^\d]/g,''));
    var otpValidStatus = isOtpValidCheck(code.replace(/[^\d]/g,''));
    setIsOtpValid(otpValidStatus);   
    setOtpDirty(true);

    if(otpValidStatus){
      document.getElementById("phoneOtp")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("phoneOtp")?.setAttribute("aria-invalid","true");
    }

  },[]);
  
  useWebOtp({ onOtp: handleWebOtp });
  // auto otp - end

  // useEffect(() => {
  //   if(typedNumber.length > 0 && !phoneDirty){
  //     setPhoneDirty(true);
  //   }
  //   if(typedNumberConfirm.length > 0 && !phoneConfirmDirty){
  //     setPhoneConfirmDirty(true);
  //   }
  //   if(otpCode.length > 0 && !otpDirty){
  //     setOtpDirty(true);
  //   }
  // },[typedNumber,typedNumberConfirm,otpCode]);

  // const handlePhoneValue = (isValid, value, countryData, number) => {
  //   value = value.replace(/[^\d\-]/g,'');     
  //   var errMsg = '';
  //   if (value.substring(0, 2) === "05" && number.substring(0,4) === "+972" && value.length === 10){
  //     isValid = true
  //   }

  //   if (isValid) {
  //     setIsPhoneValid(true); 
  //     setPhoneAriaInvalid(false);
  //   } 
  //   else {
  //     setIsPhoneValid(false);
  //     setPhoneAriaInvalid(true);
  //     if(value.length === 0){
  //       errMsg = Translate('N_General_Error_FILL_ID_MOBILE_INPUT_TEXT');
  //     }
  //     else if(number.substring(0,4) === "+972" && value.length < 10){
  //       errMsg = Translate('N_General_Error_INVALID_MOBILE_Too_short');
  //     }
  //     else{
  //       errMsg = Translate('N_General_Error_INVALID_MOBILE_1');
  //     }  
  //   }

  //   let editedPhone = number.replace(/[\s-]/g, '');
  //   setPhoneNumber(editedPhone);
  //   setTypedNumber(value);
  //   setMobileValMsg(errMsg);    

  //   if (typedNumberConfirm.length > 0) {      
  //     setTypedNumberConfirm('');      
  //   }
  // };

  // const phoneValidator = () => {
  //   if (!phoneDirty) return true;

  //   return isPhoneValid;
  // };

  // const phoneConfirmValidator = () => {
  //   if (!phoneConfirmDirty) return true;

  //   return isPhoneConfirmValid;
  // };

  // const handleFlagChange = (isValid, value, countryData, number) => {
  //   setPhoneNumber('');
  //   setTypedNumber('');
  //   setSelectedCountry(countryData.iso2);
    
  //   if(countryData.iso2 !== 'il'){
  //     setOtpType('SMS');      
  //   }
  // };

  // const handlePhoneConfirmValue = (isValid, value, countryData, number) => {
  //   if (typedNumber === value) {
  //     setIsPhoneConfirmValid(true);  
  //     setPhoneConfirmAriaInvalid(false)    
  //   } else {
  //     setIsPhoneConfirmValid(false);
  //     setPhoneConfirmAriaInvalid(true);
  //   }
   
  //   setTypedNumberConfirm(value);    
  // };

  // const handleFlagConfirmChange = (isValid, value, countryData, number) => {    
  //   setTypedNumberConfirm('');    
  // };
 
  const sendPhoneNumber = () => {
    if (!isPhoneValid || !isPhoneConfirmValid) return;

    setLoading(true);
    setServerMessage('');    

    if (ctx.devMode) {
      setLoading(false);
      setStep(2);      
      updatePhoneTemplate();
      enableResendButton();
    } else {
      Ajax.SendUserPhone(phoneNumber, otpType)
        .then(() => {
          updatePhoneTemplate();
          setLoading(false);
          setStep(2);          
          enableResendButton();
        })
        .catch((error) => {
          setLoading(false);
          setIsPhoneValid(false);
          setIsPhoneConfirmValid(false);
          setPhoneDirty(false);
          setPhoneConfirmDirty(false);
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));          
        });
    }
  };

  const updatePhoneTemplate = () => {    
    let digits = typedNumber.slice(typedNumber.length - 4);
    let templateDigits = typedNumber.slice(0, typedNumber.length - 4).replace(/[()]/g, '');
    let template = templateDigits.replace(/[\d]/g, 'X');
    let numberTemplate = `${template}${digits}`;
    setPhoneTemplate(numberTemplate);          
  };

  const enableResendButton = () => {
    setTimeout(() => setIsResendOtpEnabled(true), 60000);
  };

  const resendSms = () => {
    setLoading(true);
    setServerMessage('');    

    if (ctx.devMode) {
      setLoading(false);
      setIsResendOtpEnabled(false);      
      enableResendButton();
    } else {
      Ajax.ResendPhoneOtp(otpType)
        .then(() => {
          setLoading(false);
          setIsResendOtpEnabled(false);      
          enableResendButton();
        })
        .catch((error) => {
          setLoading(false);
          setIsResendOtpEnabled(false);
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));         
          enableResendButton();
        });
    }
  };
 
  const handleOtpEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      sendPhoneOtp();
      event.preventDefault();
    }
  };

  const handleOtpTypeEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      var otpTypeValue = otpType === 'SMS' ? 'VOICE' : 'SMS';
      setOtpType(otpTypeValue);      
      event.preventDefault();
    }
  };

  const handleOtpClick = (selectedOtp) => {
    setOtpType(selectedOtp);

    if(selectedOtp === "SMS"){
      document.getElementById("smsMessageContainer")?.setAttribute("aria-checked","true");
      document.getElementById("voiceMessageContainer")?.setAttribute("aria-checked","false");
    }
    else  if(selectedOtp === "VOICE"){
      document.getElementById("smsMessageContainer")?.setAttribute("aria-checked","false");
      document.getElementById("voiceMessageContainer")?.setAttribute("aria-checked","true");
    }   
  }

  const sendPhoneOtp = () => {
    if (!isOtpValidCheck(otpCode)) return;

    setLoading(true);
    setServerMessage('');    

    if (ctx.devMode) {
      setLoading(false);      
      props.phoneStepCompleted();
    } else {
      Ajax.SendUserPhoneOtp(otpCode)
        .then(() => {
          setLoading(false);      
          props.phoneStepCompleted();
        })
        .catch((error) => {
          setLoading(false);  
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));          
        });
    }
  };

  const isOtpValidCheck = (otp: string) => {
    const regex = /^[0-9]{6}$/;
    return regex.test(otp);
  };

  const handleOtp = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtpCode(e.target.value.replace(/[^\d]/g,''));
    var otpValidStatus = isOtpValidCheck(e.target.value);
    setIsOtpValid(otpValidStatus);   

    if(otpValidStatus){
      document.getElementById("phoneOtp")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("phoneOtp")?.setAttribute("aria-invalid","true");
    }
  };

  const otpValidationMessage = () => {
    return otpCode.length === 0
      ? Translate('N_General_Error_Mandatory_Field')
      : Translate('N_General_Error_PIN_too short');
  };

  const updatePhoneNumber = (phone:string, isValid:boolean, inputValue:string) => {
    var errMsg = '';

    setPhoneNumber(phone);
    setTypedNumber(inputValue);
    setIsPhoneValid(isValid);
    setPhoneDirty(true);
    setPhoneConfirmDirty(false);
    setResetConfirm(false);
    

    if(!isValid){
      if(inputValue.length === 0){
        errMsg = Translate('N_General_Error_FILL_ID_MOBILE_INPUT_TEXT');
      }
      else if(phone.substring(0,3) === "+972" && inputValue.length < 10){
          errMsg = Translate('N_General_Error_INVALID_MOBILE_Too_short');
      }
      else{
          errMsg = Translate('N_General_Error_INVALID_MOBILE_1');
      } 
            
      setMobileValMsg(errMsg); 

      if (confirmPhoneNumber.length > 0){
        setResetConfirm(true);
      }

    }
  };

  const updateConfirmNumber = (confimPhone:string, isValid:boolean, inputValue:string) => {
    setPhoneConfirmDirty(true);
    setConfirmPhoneNumber(confimPhone);

    if(isValid && confimPhone === phoneNumber){
      setIsPhoneConfirmValid(true);
    }
    else{
      setIsPhoneConfirmValid(false);
      if (inputValue.length === 0 ){
        setConfirmErr(Translate('N_General_Error_Mandatory_Field'));
      }
      else{
        setConfirmErr( Translate('N_General_Error_fields_dont_match'));
      }
    }
  }

  const countryChangeHandler = (country:string) => {
    if(country !== selectedCountry){
      setSelectedCountry(country);
      setPhoneNumber('');
      setResetConfirm(true);
      setIsPhoneValid(false);
      setPhoneDirty(false);
      setPhoneConfirmDirty(false);
    }
  };


  return (
    <Fragment>
      <GovSpinner show={loading} />

      <Form className='normal-form'>
        {serverMessage.length > 0 && (
          <Toast message={serverMessage} />
        )}

        {step === 1 ? (
          <Fragment>
            <Row  className='baseline phoneRow'>
              <Form.Group
                controlId='phoneNum'
                as={Col}
                xl={_curLang === 'ru' ? 6 : 5}
                lg={6}
                md={12}
                sm={12}
                xs={12}
              >
                <Form.Label className='py-2'>
                  <span>{Translate('N_General_SignUp_info_8')}</span>
                </Form.Label>
                <InputGroup>
                  <ReactInternationalPhone 
                    id="phoneNumber" 
                    getPhoneNumber= {updatePhoneNumber} 
                    countryChange = {countryChangeHandler}
                    reset = {false}  
                    disabled = {false} 
                    handleEnter={sendPhoneNumber} 
                    pasteEnabled={true}
                    ariaErrorMessage = "phoneError"
                    ariaDescribedBy = 'phoneDesc'
                  />

                </InputGroup>
                {!isPhoneValid && phoneDirty ? (
                  <div className='error mt-1 d-flex align-items-center'>
                    <img src={alert}  className='error-alert' />
                    &nbsp;
                    <span className='error-text' id="phoneError">
                      {mobileValMsg}
                    </span>
                  </div>
                ) : (                 
                  <div className='mt-1 align-items-center'>
                    <img src={info}  className='info-icon' />
                    &nbsp;
                    <span className='small' id='phoneDesc'>
                      {Translate('N_Login_personal_details_mobile_1')}
                    </span>
                  </div>
                )}
              </Form.Group>

              <Form.Group
                controlId='confirmPhoneNum'
                as={Col}
                xl={_curLang === 'ru' ? 6 : 5}
                lg={6}
                md={12}
                sm={12}
                xs={12}
              >
                <Form.Label className='py-2'>
                  <span>{Translate('N_General_SignUp_info_9')}</span>
                </Form.Label>
                <InputGroup>
                  <ReactInternationalPhone 
                    id="confirmPhoneNum" 
                    getPhoneNumber= {updateConfirmNumber} 
                    reset = {resetConfirm} 
                    countryChange = {countryChangeHandler}  
                    disabled={!isPhoneValid}   
                    selectedCountry={selectedCountry} 
                    handleEnter={sendPhoneNumber} 
                    pasteEnabled={false}  
                    ariaErrorMessage = "phoneConfirmError"
                    ariaDescribedBy = ''         
                  />

                </InputGroup>
                {!isPhoneConfirmValid &&
                  phoneConfirmDirty &&
                  isPhoneValid && (
                  <Form.Text className='error mt-1 d-flex align-items-start'>
                    <img src={alert}  className='error-alert' />
                    &nbsp;
                    <span className='error-text' id='phoneConfirmError'>
                      {confirmErr}
                    </span>
                  </Form.Text>
                )}
              </Form.Group>
            </Row>
            <div className='regular dark-blue font-weight-500' id='meesageTypeTitle'>
              {Translate('N_General_SignUp_receive_OTP')}
            </div>
            
            <div 
              className='d-flex justify-content-start radio-section message-type baseline dp-radio' 
              role="radiogroup"
              aria-labelledby="meesageTypeTitle"
            >
              <Form.Group
                tabIndex={0}
                id='smsMessageContainer'
                controlId='smsMessageType' 
                role="radio"
                aria-checked="true"
                aria-labelledby="smsTypeLbl"                
                className={`d-flex flex-row align-items-center 
                  ${otpType === 'SMS' ? ' container-radio-active ' : ' container-radio '}                                                             
                `}
                as={Col}
                xl={4}
                lg={_curLang === 'ru' ? 5 : 4}
                md={_curLang === 'ru' ? 5 : 4}
                sm={12}
                xs={12}
                onKeyPress={handleOtpTypeEnter}
                onClick={() => handleOtpClick('SMS')}
              >
                {/* <Form.Check
                  type='radio'
                  tabIndex={-1}
                  checked={otpType === 'SMS'}
                  name='sendOtpOption'
                  value='SMS'                   
                  readOnly={true}                 
                /> */}
                <input
                  type='radio'
                  tabIndex={-1}
                  checked={otpType === 'SMS'}
                  name='sendOtpOption'
                  value='SMS'                   
                  readOnly={true}        
                />
                <img
                  src={
                    otpType === 'SMS'
                      ? messageSquareActive
                      : messageSquare
                  }
                  
                />
                &nbsp;
                <Form.Label className='py-2' id='smsTypeLbl'>
                  <span>{Translate('N_General_SignUp_receive_OTP_SMS')}</span>
                </Form.Label>
              </Form.Group>

              <Col xs={1}></Col>

              <Form.Group
                tabIndex={0}
                id='voiceMessageContainer'
                controlId='voiceMessageType' 
                role="radio"
                aria-checked="false"
                aria-labelledby="voiceTypeLbl"                 
                className={`d-flex flex-row align-items-center 
                  ${otpType === 'VOICE' ? ' container-radio-active ' : ' container-radio '}
                  ${selectedCountry !== 'il' ? ' disableDivClick ' : ''}                                          
                `}
                as={Col}
                xl={4}
                lg={_curLang === 'ru' ? 5 : 4}
                md={_curLang === 'ru' ? 5 : 4}
                sm={12}
                xs={12}
                onKeyPress={handleOtpTypeEnter}
                onClick={() => handleOtpClick('VOICE')}
              >
                {/* <Form.Check                    
                  type='radio'
                  tabIndex={-1}
                  checked={otpType === 'VOICE'}
                  name='sendOtpOption'
                  value='VOICE'                 
                  readOnly={true}                    
                /> */}
                 <input
                  type='radio'
                  tabIndex={-1}
                  checked={otpType === 'VOICE'}
                  name='sendOtpOption'
                  value='VOICE'                     
                  readOnly={true}        
                />
                <img
                  src={otpType === 'VOICE' ? phoneActive : phone}
                  
                />
                &nbsp;
                <Form.Label className='py-2' id='voiceTypeLbl'>
                  <span>
                    {Translate('N_General_SignUp_receive_OTP_Voice')}
                  </span>
                </Form.Label>
              </Form.Group>
            </div>
            <Row className='mb-3 mt-2'>
              <Col xs={5}>                 
                <SubmitBtn
                  title={Translate('N_Login_personal_send_token')}
                  id="phoneSubmit"
                  action={sendPhoneNumber}
                  showIcon={false}
                  disabled={
                    !isPhoneValid ||
                    !isPhoneConfirmValid
                  }
                />
              </Col>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <div className='regular'>
              {Translate('N_General_SignUp_confirm_mobile_info_1')}
              <span className='font-weight-bold'>
                &nbsp;{phoneTemplate}
              </span>
            </div>
            <div className='regular'>
              {Translate('N_General_SignUp_confirm_mobile_info_2')}
            </div>
            <Row className='mt-3 mb-2'>
              <Form.Group
                controlId='phoneOtp'
                as={Col}
                xl={4}
                lg={4}
                md={5}
                sm={12}
                xs={12}
              >                
                <Form.Label className='my-1 d-flex align-items-center justify-content-between'>
                    <div>
                      {Translate('N_Login_reset_password_stage_2')}                                            
                    </div>
                    <div 
                      className='mx-2 d-flex align-items-center'
                      aria-hidden="true"
                      onClick={() =>
                        setControlType(
                          controlType === 'password'
                            ? 'text'
                            : 'password'
                        )
                      }
                    >
                      <img
                        src={controlType === 'password' ? eye : eyeOff}
                        width='22px'
                        height='18px'
                        
                        role='button'
                        tabIndex={0}
                        className={
                          otpCode
                            ? 'mx-1 password-view-show'
                            : 'mx-1 password-view-hide'
                        }
                        
                      />
                      <span 
                        className={
                          otpCode
                            ? 'password-view-show'
                            : 'password-view-hide'
                        }
                      >
                        {controlType === 'password' 
                          ? Translate('N_Login_Bio_ID_OTP_Show_OTP')
                          : Translate('N_Login_Bio_ID_OTP_Hide_OTP')
                        }
                      </span>                      
                    </div>
                </Form.Label>
                <Form.Control
                  type={controlType}
                  value={otpCode}
                  aria-required="true"
                  autoComplete="one-time-code"
                  placeholder="_ _ _ _ _ _"
                  onChange={handleOtp}
                  onKeyPress={handleOtpEnter}
                  maxLength={6}
                  aria-describedby = "phoneOtpDesc"  
                  aria-invalid="false"
                  aria-errormessage="phoneOtpErr" 
                  className={`gov-black
                    ${!isOtpValid && otpDirty
                      ? ' error-control'
                      : ''
                    }
                  `}
                />                
                {!isOtpValid && otpDirty ? (
                  <Form.Text className='error d-flex align-items-start'>
                    <img src={alert}  className='error-alert' />
                    &nbsp;
                    <span className='error-text' id='phoneOtpErr'>
                      {otpValidationMessage()}
                    </span>
                  </Form.Text>
                ) : (
                  <Form.Text className='small dark-blue d-flex align-items-center'>
                    <img src={timer}  width='16px' height='19px' />
                    &nbsp;
                    <span className='py-2' id='phoneOtpDesc'>
                      {Translate('N_General_otp_time_limit_1')}
                    </span>
                  </Form.Text>
                )}
              </Form.Group>
            </Row>
            <div className='small dark-blue align-items-center'>
              {Translate('N_General_SignUp_confirm_mobile_info_4')}
              <Button
                variant='link'
                id='phoneOtpResened'
                className='small vivid-main-blue'
                onClick={resendSms}
                disabled={!isResendOtpEnabled}
              >
                {Translate('N_General_SignUp_confirm_mobile_info_5')}
              </Button>
            </div>
            <Row className='mb-3'>
              <Col 
                xl={4}
                lg={4}
                md={5}
                sm={12}
                xs={12}
              >                  
                <SubmitBtn
                  title={Translate('N_General_next_butten')}
                  id="phoneOtpSubmit"
                  action={sendPhoneOtp}
                  showIcon={false}
                  disabled={!isOtpValid}
                />
              </Col>
            </Row>
          </Fragment>
        )}
      </Form>
    </Fragment>
  );
};
export default DetailsPhone;


